/* eslint-disable react/jsx-no-bind */
import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Button, LoadingIndicator } from '@components';
import { useNavigate } from 'react-router-dom';
import { Document, Page, pdfjs } from 'react-pdf';

import { EmprestimoService } from '../../../common/services/emprestimo';

const options = {
  cMapUrl: 'cmaps/',
  cMapPacked: true,
  standardFontDataUrl: 'standard_fonts/',
};

export const RegulamentoEmprestimoPage = () => {
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

  const navigate = useNavigate();
  const [file, setFile] = useState('');
  const [numPages, setNumPages] = useState(null);
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(true);

  function onDocumentLoadSuccess({ numPages: nextNumPages }) {
    setNumPages(nextNumPages);
  }

  useEffect(() => {
    const service = new EmprestimoService();

    service
      .obterURLPDFRegulamentoEmprestimo()
      .then((res) => {
        setFile(res);
      })
      .finally(() => setLoading(false));
  }, []);

  return loading ? (
    <LoadingIndicator />
  ) : (
    <>
      <Helmet>
        <title>Forluz - Percentual Recebimento Renda Mensal</title>
      </Helmet>
      <h1 className="page-title mb-3">
        <strong>Regulamento dos Empréstimos</strong>
      </h1>
      <hr className="my-4" />
      <div className="d-flex col-3 col-md-2 col-lg-1 justify-content-center">
        <Button
          className="justify-content-center mb-32"
          transparent
          color="orange"
          icon="arrow_back"
          onClick={() => navigate(-1)}
        >
          Voltar
        </Button>
      </div>
      <div className="card">
        <div className="card-body">
          <div className="row">
            <div className="col-12 col-md-6 col-lg-6 mb-4">
              <p className="text-muted ts-20">
                O empréstimo da Forluz é considerado uma modalidade de
                investimento. Para fazer a solicitação, o participante deve
                atender a alguns requisitos.
                <br />
                <br />
                Antes de tirar o empréstimo, é importante você conhecer o
                regulamento para se inteirar de suas condições e exigências.
              </p>
              <div className="row mt-32 justify-content-center">
                <div className="col-6">
                  <a
                    href={file}
                    rel="noreferrer"
                    target="_blank"
                    download
                    title="Clique para baixar o regulamento"
                    className="d-flex ts-14 mb-2 mt-4 aButtonTransparent"
                  >
                    Baixar regulamento
                  </a>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-6 mb-4">
              <div>
                <Document
                  file={window.origin + file}
                  onLoadSuccess={onDocumentLoadSuccess}
                  options={options}
                  loading="Carregando PDF..."
                >
                  <Page key={`page_${page}`} pageNumber={page + 1} />
                  <div className="row justify-content-center mt-32">
                    <div className="col-2">
                      <Button
                        className="only-icon"
                        disabled={page === 0}
                        onClick={() => setPage(page - 1)}
                        icon="arrow_back"
                      />
                    </div>
                    <div className="col-2">
                      <p className="text-orange fw-bold mt-2">{`${
                        page + 1
                      } / ${numPages}`}</p>
                    </div>
                    <div className="col-2">
                      <Button
                        className="only-icon"
                        disabled={page === numPages - 1}
                        onClick={() => setPage(page + 1)}
                        icon="arrow_forward"
                      />
                    </div>
                  </div>
                </Document>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
